import type { SearchFacets } from '@pms/shared';
import { PriceRangeFilter } from './PriceRangeFilter';
import { AmenitiesFilter } from './AmenitiesFilter';
import { GuestRatingFilter } from './GuestRatingFilter';

interface FiltersBodyProps {
  facets: SearchFacets | undefined;
  price: { min?: number | undefined; max?: number | undefined };
  amenities: string[];
  minRating: number;
  currency?: string | undefined;
  onPriceChange: (next: { min?: number | undefined; max?: number | undefined }) => void;
  onAmenitiesChange: (next: string[]) => void;
  onRatingChange: (next: number) => void;
}

/** Shared filter controls used by both the desktop rail and the mobile sheet. */
export function FiltersBody({
  facets,
  price,
  amenities,
  minRating,
  currency,
  onPriceChange,
  onAmenitiesChange,
  onRatingChange,
}: FiltersBodyProps) {
  return (
    <div className="divide-y divide-sand">
      <div className="pb-6">
        <GuestRatingFilter value={minRating} onChange={onRatingChange} />
      </div>
      <div className="py-6">
        <PriceRangeFilter
          bounds={facets?.priceBounds ?? null}
          value={price}
          currency={currency}
          onChange={onPriceChange}
        />
      </div>
      <div className="pt-6">
        <AmenitiesFilter
          options={facets?.amenities ?? []}
          selected={amenities}
          onChange={onAmenitiesChange}
        />
      </div>
    </div>
  );
}
